import {BigNumber, FormattableCurrency} from '@ttx/core';
import {useRouter} from 'next/router';
import {WalletNetwork} from '../contexts/authentication-context/types';
import {useTtxQuery} from './ttx-trpc';

export const useTreasuryBalance: ({
  currency,
  amount,
  network,
}: {
  currency: FormattableCurrency | null;
  amount: BigNumber;
  network?: WalletNetwork;
}) => {
  canUseCash: boolean;
  maxQuantityAvailableToPurchase: number;
  isLoading: boolean;
} = ({amount, currency, network}) => {
  const router = useRouter();
  const {data, isLoading, refetch, isRefetching} = useTtxQuery(
    ['evm.treasuryBalance', {network}],
    {
      enabled:
        !!network &&
        network !== 'zilliqa' &&
        !router.pathname.includes('/multidrop-form'),
      onSuccess: ({balances}) => {
        // Short term fix to work with the api
        if (
          balances.MATIC === '0' &&
          balances.TRAXX === '0' &&
          balances.USDT === '0'
        ) {
          refetch();
        }
      },
    },
  );

  const availableAmountForCurrency = currency
    ? (data?.balances as any)?.[currency]
    : null;

  const maxQuantityAvailableToPurchase = Math.floor(
    Number(availableAmountForCurrency) / Number(amount),
  );

  const canUseCash =
    Number(availableAmountForCurrency) > Number(amount.toString()) ||
    ['ETH', 'MATIC'].includes(currency as string);

  return {
    isLoading: isLoading || isRefetching,
    canUseCash,
    maxQuantityAvailableToPurchase,
  };
};
